import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Building2, Check, ArrowRight, MapPin } from "lucide-react";

const POINTS = [
  "Consulenza e adempimenti secondo il D.Lgs. 81/08",
  "Formazione obbligatoria e aggiornamento del personale",
  "Formazione finanziata",
  "Soluzioni personalizzate in base al settore e alle esigenze aziendali",
];

const CERTIFICATIONS = [
  ["Certificazioni FGAS", "persone e imprese"],
  ["ISO 9001", "Sistema di Gestione della Qualità"],
  ["ISO 14001", "Sistema di Gestione Ambientale"],
  ["ISO 45001", "Sistema di Gestione della Salute e Sicurezza sul Lavoro"],
  ["ISO 50001", "Sistema di Gestione dell'Energia"],
  ["SA 8000", "Responsabilità Sociale"],
];

const IMG = "/gallery/aula-azienda.jpg";

export const Aziende = ({ onRequestQuote }) => {
  return (
    <section id="aziende" data-testid="aziende-section" className="py-24 md:py-32 bg-white border-y border-border">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ clipPath: "inset(0 0 100% 0)" }}
          whileInView={{ clipPath: "inset(0 0 0% 0)" }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5 relative h-[360px] md:h-[480px] overflow-hidden bg-brand-black order-2 lg:order-1"
        >
          <img src={IMG} alt="Formazione sicurezza per aziende" className="w-full h-full object-cover" />
          <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/70 to-transparent">
            <div className="flex items-center gap-2 text-white text-sm font-bold uppercase tracking-widest">
              <MapPin size={16} className="text-brand-red" /> In sede o in azienda
            </div>
          </div>
        </motion.div>

        <div className="lg:col-span-6 lg:col-start-7 order-1 lg:order-2">
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-brand-red mb-5">
            <Building2 size={16} /> Per la tua azienda
          </div>
          <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tighter text-brand-black leading-[0.95] mb-6">
            La sicurezza della tua azienda, dalla A alla Z.
          </h2>
          <p className="text-brand-ink leading-relaxed mb-8 max-w-xl">
            Offriamo consulenza e formazione per aiutarti a gestire gli obblighi di sicurezza,
            organizzare gli adempimenti e formare il tuo personale, con un supporto completo
            e professionale.
          </p>

          <ul className="space-y-3 mb-9">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-brand-black">
                <Check size={18} className="text-brand-red mt-0.5 shrink-0" />
                {p}
              </li>
            ))}
          </ul>

          <div className="mb-9 border-t border-border pt-7" data-testid="aziende-certifications">
            <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-brand-ink mb-4">
              Certificazioni
            </div>
            <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3">
              {CERTIFICATIONS.map(([name, desc]) => (
                <li key={name} className="flex items-start gap-3">
                  <Check size={18} className="text-brand-red mt-0.5 shrink-0" />
                  <div>
                    {name.includes("FGAS") ? (
                      <Link to="/fgas" data-testid="aziende-fgas-link" className="font-heading font-bold text-brand-black leading-tight underline decoration-brand-red underline-offset-4 hover:text-brand-red transition-colors">{name}</Link>
                    ) : (
                      <div className="font-heading font-bold text-brand-black leading-tight">{name}</div>
                    )}
                    <div className="text-xs text-brand-ink">{desc}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-wrap items-center gap-4">
            <button
              onClick={onRequestQuote}
              data-testid="aziende-quote-cta"
              className="group inline-flex items-center gap-2 bg-brand-red text-white font-bold uppercase tracking-widest text-sm px-8 py-4 hover:bg-brand-black transition-colors"
            >
              Richiedi un preventivo
              <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <span className="text-sm text-brand-ink">Risposta entro 24h lavorative</span>
          </div>
        </div>
      </div>
    </section>
  );
};
